import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

const A = "https://customer-assets.emergentagent.com/job_bodendesign-staging/artifacts";

const projects = [
  {
    title: "Designterrasse mit Rauten-Inlay",
    area: "Terrasse",
    color: "Anthrazit + Carrara",
    size: "Showcase 2020",
    img: `${A}/5zkugav4_20190403_122122.jpg`,
  },
  {
    title: "Mediterrane Terrasse mit Mäander",
    area: "Terrasse",
    color: "Bardiglio + Carrara",
    size: "Sonderanfertigung",
    img: `${A}/7qqawjej_Bild%20IHM%202020.jpg`,
  },
  {
    title: "Eingang mit Rauten-Inlay",
    area: "Eingang / Gehweg",
    color: "Carrara + Nero Ebano",
    size: "Treppe + Podeste",
    img: `${A}/ekzy7pu3_20130530_095755.jpg`,
  },
  {
    title: "Dachterrasse mit Treppenabgang",
    area: "Außenfläche",
    color: "Grigio Carnico",
    size: "Großfläche",
    img: `${A}/4r8rppgj_IMG-20180726-WA0015.jpg`,
  },
  {
    title: "Küche mit Kaffeebohnen-Inlay",
    area: "Innenraum / Küche",
    color: "Botticcino + Rouge Royal",
    size: "Kreativ-Inlay",
    img: `${A}/lb81l1qi_20180124_132739.jpg`,
  },
  {
    title: "Walk of Fame – Walt Disney Stern",
    area: "Kreativ-Inlay",
    color: "Nero Ebano + Botticcino",
    size: "Sonderanfertigung",
    img: `${A}/30jstbif_WP_000011%281%29.jpg`,
  },
  {
    title: "Eingang mit Kompass-Inlay",
    area: "Eingangsbereich",
    color: "Verde Alpi + Carrara",
    size: "Stern-Sonderdesign",
    img: `${A}/l9jlmrjf_20130727_181110-1.jpg`,
  },
  {
    title: "Balkon Rotbraun mit Bordüre",
    area: "Balkon",
    color: "Rosso Verona + Rouge Royal",
    size: "ca. 14 m²",
    img: `${A}/nm4e7wy8_IMG-20190620-WA0003.jpg`,
  },
  {
    title: "Außentreppe & Eingangspodest",
    area: "Treppe / Eingang",
    color: "Grigio Carnico",
    size: "4 Stufen + Podest",
    img: `${A}/bnigcquv_IMG-20230610-WA0003.jpg`,
  },
  {
    title: "Hauseingang & Gehweg",
    area: "Gehweg / Eingang",
    color: "Anthrazit Mix",
    size: "ca. 45 m²",
    img: `${A}/tytsgh3t_IMG-20190601-WA0003.jpg`,
  },
  {
    title: "Duschbereich mit Steinteppich-Wand",
    area: "Bad / Innen",
    color: "Nero Ebano",
    size: "Wand + Boden",
    img: `${A}/cjnn6kzh_20190314_163525.jpg`,
  },
  {
    title: "Badezimmer Wandgestaltung",
    area: "Innenraum / Bad",
    color: "Nero Ebano",
    size: "Wand + Sockel",
    img: `${A}/he4j0ww0_20190314_163608.jpg`,
  },
  {
    title: "Getränkefachmarkt",
    area: "Gewerbe",
    color: "Bardiglio Mix",
    size: "Verkaufsfläche",
    img: `${A}/bxtrwuae_20141010_155928%20%281%29.jpg`,
  },
  {
    title: "Gewerbe-Lagerhalle",
    area: "Gewerbe / Innen",
    color: "Bardiglio Mix",
    size: "Großfläche",
    img: `${A}/7e92ghcj_20140924_141936%20%281%29.jpg`,
  },
  {
    title: "Schauraum-Designobjekt",
    area: "Showroom",
    color: "Botticcino + Rouge Royal",
    size: "Materialprobe 3D",
    img: `${A}/7crtfzyw_20210111_134236.jpg`,
  },
];

export default function Projekte() {
  return (
    <div data-testid="projekte-page">
      <section className="pt-32 pb-20 bg-white border-b border-stone-200">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-xs uppercase tracking-[0.3em] text-stone-500 mb-6">
            Projekte
          </div>
          <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight max-w-3xl">
            Ausgewählte Referenzen.
          </h1>
          <p className="mt-8 max-w-2xl text-stone-600 leading-relaxed">
            Ein Auszug realisierter Projekte – privat und gewerblich, innen
            und außen. Jedes Projekt: individuell geplant, präzise umgesetzt.
          </p>
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="projects-grid">
            {projects.map((p, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.55, delay: (i % 3) * 0.07 }}
                className="group"
                data-testid={`project-card-${i}`}
              >
                <div className="aspect-[4/5] overflow-hidden bg-stone-100">
                  <img
                    src={p.img}
                    alt={p.title}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                </div>
                <div className="mt-5 flex items-start justify-between gap-4">
                  <div>
                    <div className="text-xs uppercase tracking-[0.25em] text-stone-500">
                      {p.area}
                    </div>
                    <div className="font-heading text-lg font-medium mt-1">
                      {p.title}
                    </div>
                  </div>
                  <div className="text-right text-xs text-stone-500 shrink-0">
                    <div>{p.color}</div>
                    <div className="mt-1">{p.size}</div>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-24 bg-[#1C1C1C] text-white">
        <div className="max-w-5xl mx-auto px-6 lg:px-8 text-center">
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight">
            Ihr Projekt – unsere Handschrift.
          </h2>
          <Link
            to="/kontakt"
            data-testid="projekte-cta"
            className="mt-10 inline-flex items-center gap-2 px-8 py-4 rounded-full bg-white text-[#1C1C1C] text-sm hover:bg-stone-100 transition-colors"
          >
            Beratung anfragen <ArrowRight size={16} />
          </Link>
        </div>
      </section>
    </div>
  );
}
